const {createBrowserHistory} = require("history")


export const history = createBrowserHistory()